import React, { useState } from "react";
import "../index.css";
import "../css/Header.css";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <header className="wrap_sticky">
      <a href="#" className="top-disclaimer w-inline-block">
        <div className="text-block-2">
          New feature: Create repair requests, manage your tickets and estimates
          with Furloop!
        </div>
      </a>

      <div className="navbar md:px-36">
        <div className="flex-1" style={{ display: "inline-block" }}>
          <Link to="/" className="btn btn-ghost">
            <img
              src="https://cdn.shopify.com/s/files/1/0612/1875/0717/files/Layer_1.svg?v=1725726186" // Replace with the actual file path to your logo
              alt="FurLoop"
              className="logo-brand-1 w-embed" // Set the height of the logo
            />
          </Link>
        </div>
        <div className="flex-none">
          <ul className="menu p-[0rem] menu-horizontal flex items-center">
            <li className="flex items-center">
              {/* Desktop Discord Icon */}
              <a
                href="https://discord.gg/qWGdTE5y"
                target="_blank"
                rel="noopener noreferrer"
                className="desktop-discord"
              >
                <img
                  src="/Discord.png"
                  alt="Discord"
                  style={{
                    width: '165px',
                    height: 'auto',
                    background: 'transparent',
                    padding: '0',
                    margin: '0'
                  }}
                  className="mr-2"
                />
              </a>
            </li>
            <li>
              <Link to="/sign-up-today" className="btn btn-outline btn-primary">
                Sign Up
              </Link>
            </li>
            {/* <li>
              <Link to="/blog" className="btn btn-outline btn-primary ml-2">Blog</Link>
            </li> */}
            <li>
              <a
                href="https://app.furloop.io/reseller/"
                className="btn btn-outlline btn-primary ml-2"
              >
                Log In
              </a>
              {/* <Link to="/sign-in-today" className="btn btn-outline btn-primary">Log In</Link> */}
            </li>
            <li className="flex items-center">
              <a
                href="https://discord.gg/qWGdTE5y"
                target="_blank"
                rel="noopener noreferrer"
                className="mobile-discord"
              >
                <img
                  src="/Discord_mobile.png"
                  alt="Discord"
                  style={{
                    width: '60px',
                    height: 'auto',
                    background: 'transparent',
                    padding: '0',
                    margin: '0'
                  }}
                />
              </a>
            </li>
            <li className="flex items-center">
              <details>
                <summary className="flex items-center cursor-pointer">
                  <span className="desktop-more">More</span>
                  <div className="mobile-menu-items flex items-center">
                    <svg className="mobile-dots w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                      <circle cx="12" cy="12" r="2"/>
                      <circle cx="12" cy="5" r="2"/>
                      <circle cx="12" cy="19" r="2"/>
                    </svg>
                  </div>
                </summary>
                <ul className="bg-white rounded-t-none p-2">
                  <li>
                    <a href="#pricing" className="no-underline">
                      Pricing
                    </a>
                  </li>
                  <li>
                    <Link to="/blog" style={{ textDecoration: "none" }}>
                      Articles
                    </Link>
                  </li>
                  <li>
                    <a
                      href="https://app.furloop.io/affiliates/?shop=mem_sb_EUt5mRSNpeSrriGwSrpdiLT"
                      style={{ textDecoration: "none" }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Demo Store
                    </a>
                  </li>
                </ul>
              </details>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Header;
